import React from "react";
import Hero from "../components/Hero";
import GetTheApp from "../components/GetTheApp";
import PillarsSection from "../components/PillarsSection";
import WhyLongev from "../components/WhyLongev";
import PackagesGrid from "../components/PackagesGrid";
import AssessmentPromo from "../components/AssessmentPromo";
import FounderSection from "../components/FounderSection";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import BookCTA from "../components/BookCTA";

export default function HomePage() {
  return (
    <>
      <Hero />
      <GetTheApp />
      <PillarsSection />
      <WhyLongev />
      <AssessmentPromo />
      <PackagesGrid />
      <FounderSection />
      <Testimonials />
      <FAQ />
      <BookCTA />
    </>
  );
}
